import React, {PropTypes} from 'react';
import Display from '../parts/display';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import { browserHistory, Link } from 'react-router';
import ClientsBlock from '../clientsBlock';
import BlogBlock from '../blogBlock';
import PortfolioBlock from './portfolioBlock';
import Select from '../parts/select';
import {debounce} from 'throttle-debounce';


class PortfolioPage extends React.Component {
	constructor() {
		super();
		this.state = {
			animated: false,
			selected: '',
			pageSlug: false,
			page: 1,
			activeService: false,
			searchString: ''
		};
		this.portfolioSelected = this.portfolioSelected.bind(this);
		this.getServiceType = this.getServiceType.bind(this);
		this.updateItems = this.updateItems.bind(this);
		this.search = debounce(600, this.search);
		this.onChange = this.onChange.bind(this);
	}
	componentWillMount(){
		this.props.actions.loadService(false, 20, this.state.page);
		window.scrollTo(0,0);
	}
	componentDidMount() {
		this.props.actions.showNavBar(true);
		this.props.actions.showMenu(true);
		if((this.props.location.pathname.match(/\//g) || []).length == 2){
			let name = this.props.location.pathname.substring(11, this.props.location.pathname.length);
			this.props.actions.loadService(_find(this.props.site.services, {slug: name}), 20, this.state.page);
			this.setState({
				pageSlug: name
			});
		}
		if(this.props.site.posts.length < 1){
			this.props.actions.loadBlogPosts(3,1);
		}
	}
	portfolioSelected(name){
		this.setState({
			selected: name
		})
	}
	updateItems(slug, page){
		let p;

		if(Number(page) === page && page % 1 === 0) p = page;
		else p = this.state.page;

		if(this.state.activeService !== slug){
			p = 1;
		}

		if(slug === 'any'){
			this.props.actions.loadService(_find(this.props.site.services, {slug: slug}), 20, p);
			this.props.actions.clearSelectedService();
		}else{
			this.props.actions.loadService(_find(this.props.site.services, {slug: slug}), 20, p);
		}

		this.setState({
			activeService: slug,
			page: p
		});
	}
	getServiceType(type){
		return _filter(this.props.site.services, {type: type});
	}
	componentWillUnmount(){
		this.props.actions.clearState();
	}
	onChange(e){
		this.search(e.target.value);
	}
	search(val){
		this.setState({
			searchString: val,
			activeService: ''
		});

		if(this.props.site.selectedService){
			this.props.actions.clearSelectedService();
		}

		if(val.length > 2){
			this.props.actions.searchPortfolios(val)
		}else if(val.length == 0){
			this.props.actions.loadService(_find(this.props.site.services, {slug: 'any'}));
		}
	}
	render() {
		return (
			<div className="services-page animated fadeIn portfolio-page">
				<div className="portfolio-top">
					<div className="container">
						<div className="row">
							<h1><span>/</span> Portfolio</h1>
							<div className="dash-separator"></div>
							<div className="filters">
								<span>Filter by<i>::</i></span>
								<Select items={this.props.site.specialisms} name="Specialism" updateItems={this.updateItems} activeSlug={this.state.activeService} />
								<span>|</span>
								<Select items={this.props.site.skillsets} name="Skillset" updateItems={this.updateItems} activeSlug={this.state.activeService}/>
							</div>
							<div className="search-wrapper input-wrapper">
								<input type="text" placeholder="Search" onChange={this.onChange} />
								<div className={this.props.site.searchingPortfolios? "uil-ring-css searching": "uil-ring-css"}><div></div></div>
							</div>
							<Display if={this.props.site.selectedService.name}>
								<h2 className="portfolio-name" dangerouslySetInnerHTML={{__html: this.props.site.selectedService.name}}></h2>
							</Display>
						</div>
					</div>
				</div>

					<PortfolioBlock items={this.props.site.selectedPortfolios} title={false} pathname={this.props.location.pathname} services={false} pageSlug={this.state.pageSlug} page={this.props.params.id} children={this.props.children} />
					<Display if={this.props.site.selectedPortfolios.length % 20 === 0 && !this.props.site.loadingPortfolio && !this.state.searchString}>
						{/*<p className="load-more-btn" >Load More</p>*/}
						<div className="load-more-arrow" onClick={()=>{this.updateItems(this.state.activeService, this.state.page + 1)}}>
							<i className="fa fa-angle-down"></i>
						</div>
					</Display>
					<ClientsBlock clients={this.props.site.selectedClients} />

				<BlogBlock posts={this.props.site.posts} maxPosts={3} />
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		site: state.site
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(siteActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/portfolio/portfolioPage.js
 **/